import { InjectiveArchiverRpc } from '@injectivelabs/indexer-proto-ts';
import { IndexerArchiverStreamTransformer } from '../transformers/index.js';
import { getGrpcIndexerWebImpl } from '../../base/BaseIndexerGrpcWebConsumer.js';
/**
 * @category Indexer Grpc Stream
 */
export class IndexerGrpcArchiverStream {
    client;
    constructor(endpoint) {
        this.client = new InjectiveArchiverRpc.InjectiveArchiverRPCClientImpl(getGrpcIndexerWebImpl(endpoint));
    }
    streamSpotAverageEntries({ account, callback, onEndCallback, onStatusCallback, }) {
        const request = InjectiveArchiverRpc.StreamSpotAverageEntriesRequest.create();
        request.account = account;
        const subscription = this.client
            .StreamSpotAverageEntries(request)
            .subscribe({
            next(response) {
                callback(IndexerArchiverStreamTransformer.spotAverageEntriesStreamCallback(response));
            },
            error(err) {
                if (onStatusCallback) {
                    onStatusCallback(err);
                }
            },
            complete() {
                if (onEndCallback) {
                    onEndCallback();
                }
            },
        });
        return subscription;
    }
}
